import { Avatar, Flex, Button } from "antd"
import { Text } from "ui/Typography"
import { systemPrompts } from "../constants"
import { spacings } from "themes/variables"
import { useTranslation } from "react-i18next"
import ai from "assets/icons/ai.svg"
import styles from "../ChatBox.module.css"
import PropTypes from "prop-types"

const SystemPrompt = ({ handlePromptClick, selectedPrompt }) => {
  const { t } = useTranslation()

  return (
    <Flex vertical gap={spacings.M}>
      <Flex align="center" gap={spacings.S}>
        <Avatar src={ai} size={32} className={styles.headerAvatar} />
        <Text className={styles.aiMessage}>{t("ai_assistant.hi")}</Text>
      </Flex>
      <Flex justify="center" gap={spacings.XS} wrap>
        {systemPrompts.map((prompt) => (
          <Button
            key={prompt.id}
            className="py-xs px-l"
            variant="outlined"
            color="primary"
            icon={prompt.icon}
            disabled={!!selectedPrompt}
            type={selectedPrompt === prompt.title ? "primary" : "default"}
            onClick={() => handlePromptClick(prompt.title)}
          >
            {prompt.title}
          </Button>
        ))}
      </Flex>
    </Flex>
  )
}

SystemPrompt.propTypes = {
  handlePromptClick: PropTypes.func.isRequired,
  selectedPrompt: PropTypes.string
}

export default SystemPrompt
